/**
 * campaignReportFooterColumnDefinition - list of configurations for columns that contain non-default footer only.
 * This configuration is merged with grid column configuration by DataGrid using `field` as a key for merging.
 * Merge of all props is done with Object.assign mechanism, except `type` property.
 * `type` of footer config is appended to grid column config `type`.
 * `type` is appended because footer config should contain rest of functionality defined by grid column config.
 * Possible to set footer config without any type (not even from grid column config), by setting: `type: null` in
 * footer config.
 *
 * NOTE: The footer `type` should be last in the list of configurations in order to override all props of previous
 * types.
 */
import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { CAMPAIGN_REPORT_ID } from './campaignReportId';

const emptyColumns = [
    FIELDS.IS_SELECTED,
    FIELDS.IS_ACTIVE,
    FIELDS.ID,
    FIELDS.DEMAND_TYPE,
    FIELDS.NAME,
    FIELDS.BUDGET,
    FIELDS.BID,
    FIELDS.ACCOUNT_MANAGER,
    FIELDS.SALES_PERSON,
    FIELDS.STATUS,
    FIELDS.START_DATE,
    FIELDS.END_DATE,
    FIELDS.BID_STRATEGY,
    FIELDS.SAFETY_LEVEL,
    FIELDS.ACTIONS_COLUMN,
    FIELDS.ACCOUNT_ID,
    FIELDS.ACCOUNT_DESCRIPTION,
    FIELDS.CAMPAIGNS_GROUP_NAME,
    FIELDS.SPENDING_LIMIT,
    FIELDS.CPA_GOAL,
    FIELDS.CPC_CAP,
    FIELDS.CAMPAIGN_CONVERSION_RULES,
    FIELDS.ESTIMATED_DAILY_CAP,
].map(createFooterMapper(CAMPAIGN_REPORT_ID));

const campaignReportFooterColumnDefinition = [...emptyColumns];

export default campaignReportFooterColumnDefinition;
